// Set to track which stories have been viewed in the current session
const viewedStories = new Set();
const completedStories = new Set();

/**
 * Track a story view, ensuring it's only tracked once per session
 * @param {number} storyId - The ID of the story to track
 * @returns {Promise} - The result of the tracking API call, or null if already tracked
 */
export const trackStoryView = (storyId) => {
  // Convert to string to ensure consistent comparison
  const storyIdStr = String(storyId);
  
  // Only track if not already tracked in this session
  if (!viewedStories.has(storyIdStr)) {
    viewedStories.add(storyIdStr);
    
    // Import dynamically to avoid circular dependencies
    const StoryService = require('../services/story').default;
    
    return StoryService.trackStoryView(storyId)
      .catch(error => {
        console.error('Error tracking story view:', error);
        // Remove from set if tracking failed, so we can try again
        viewedStories.delete(storyIdStr);
      });
  }
  
  return Promise.resolve(null);
};

/**
 * Track a story completion, ensuring it's only tracked once per session
 * @param {number} storyId - The ID of the story to track
 * @returns {Promise} - The result of the tracking API call, or null if already tracked
 */
export const trackStoryCompletion = (storyId) => {
  // Convert to string to ensure consistent comparison
  const storyIdStr = String(storyId);
  
  // Only track if not already tracked in this session
  if (!completedStories.has(storyIdStr)) {
    completedStories.add(storyIdStr);
    
    // Import dynamically to avoid circular dependencies
    const StoryService = require('../services/story').default;
    
    return StoryService.trackStoryCompletion(storyId)
      .catch(error => {
        console.error('Error tracking story completion:', error);
        // Remove from set if tracking failed, so we can try again
        completedStories.delete(storyIdStr);
      });
  }
  
  return Promise.resolve(null);
};